import React from "react";

function Privacy() {
  return (
    <div className="md:py-16">
      <div class="max-w-screen-xl mx-auto p-5 md:p-4">
        <h1 class="text-4xl font-semibold pb-5">Privacy Policy</h1>
        <p class="text-md pb-5">
          At Live Number Generator, we value your privacy and are committed to
          protecting your personal information. This Privacy Policy outlines
          what data we collect and how we use it.
        </p>
        <p class="text-md pb-5">
          1. Information We Collect: We do not collect any personal data unless
          explicitly provided by you (e.g., via a contact form). Usage
          statistics may be collected anonymously to improve our service (e.g.,
          through analytics tools). <br />
          <br />
          2. How We Use Your Data: Any collected information is used only to
          improve the app’s performance and user experience. We do not sell,
          share, or rent your personal information to third parties.
          <br />
          <br />
          3. Cookies: Our site may use cookies to store preferences or improve
          usability. You can control cookies via your browser settings.
          <br />
          <br />
          4. Data Security: We implement standard security practices to ensure
          your information remains safe and protected.
          <br />
          <br />
          5. Changes to This Policy: This Privacy Policy may be updated
          occasionally. Continued use of the site indicates your agreement with
          any changes.
          <br />
          <br />
          6. Contact Us: If you have any questions about our Privacy Policy,
          feel free to reach out at
          <a href="mailto:info@livenumbergenerator"> <b>info@livenumbergenerator</b> </a>.
        </p>
        <p class="text-md pb-5">
          We do not require any login or permissions that access your personal
          files or information. Your usage of this app is entirely private. By
          using this app, you agree to these terms. If you have any questions,
          contact us.
        </p>
      </div>
    </div>
  );
}

export default Privacy;
